// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServData" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SelfServQuestionGenShape } from "./self-serv-question.gen";
import { SelfServSnippetGenShape } from "./self-serv-snippet.gen";
import { SelfServAdviceSetGenShape } from "./self-serv-advice-set.gen";
import { SelfServTagGenShape } from "./self-serv-tag.gen";
import { SelfServVariableGenShape } from "./self-serv-variable.gen";

export const SelfServDataGenShape = z.strictObject({
  teamId: z.string(),
  treeId: z.string(),
  startText: z.string().optional(),
  contactText: z.string().optional(),
  noticeTitle: z.string().optional(),
  noticeHtml: z.string().optional(),
  questions: z.array(SelfServQuestionGenShape),
  snippets: z.array(SelfServSnippetGenShape),
  adviceSets: z.array(SelfServAdviceSetGenShape),
  tags: z.array(SelfServTagGenShape),
  variables: z.array(SelfServVariableGenShape),
  errors: z.array(z.string()).optional(),
  lastEdited: z.string().optional(),
  id: z.string(),
});
